import { createEntityAdapter } from '@reduxjs/toolkit'

import { RunsheetStop } from '../models/runsheet/RunsheetStop'

export const runsheetStopsAdapter = createEntityAdapter({
  selectId: (stop: RunsheetStop) => stop.id,
})
